<div
  class="badge"
  [class.badge-large]="size === 'large'"
  [ngClass]="'badge-' + variant"
  >
  <!-- Dot indicator -->
  @if (indicator === 'dot') {
    <span class="badge-dot"> </span>
  }

  <!-- Icon indicator -->
  @if (indicator === 'icon') {
    <hyperkit-icon
      [icon]="icon"
      size="small"
      color="inherit"
      class="badge-icon"
      >
    </hyperkit-icon>
  }

  <hyperkit-typography variant="emphasized" size="sm" color="inherit">{{
    text
  }}</hyperkit-typography>
</div>
